import React, { Fragment } from 'react';
import { motion } from 'framer-motion';
import { ArrowDown } from 'lucide-react';
export function Slide9Agencies() {
  const steps = [{
    text: 'Takeda / agency strategy',
    type: 'takeda'
  }, {
    text: 'Approved content and messages',
    type: 'takeda'
  }, {
    text: 'Snakker interactive format',
    type: 'snakker'
  }, {
    text: 'Multi-channel deployment',
    type: 'shared'
  }, {
    text: 'Engagement data and report',
    type: 'snakker'
  }, {
    text: 'Next recommendation',
    type: 'snakker'
  }];
  return <div className="h-full w-full bg-[#F8F9FA] text-[#2D3748] flex flex-col p-12 md:px-24 md:pt-16 md:pb-24 relative overflow-hidden" data-id="element-269">
      <header className="mb-12" data-id="element-270">
        <motion.h2 className="text-4xl md:text-5xl font-bold text-[#1A202C] mb-4" initial={{
        opacity: 0,
        x: -20
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-271">
          Built to complement Takeda’s existing agency model.
        </motion.h2>
        <motion.p className="text-xl text-[#4A5568] font-light max-w-3xl" initial={{
        opacity: 0,
        x: -20
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.6,
        delay: 0.1
      }} data-id="element-272">
          Snakker turns approved strategy and content into interactive
          engagement journeys.
        </motion.p>
      </header>

      <main className="flex-1 flex items-center justify-between gap-16" data-id="element-273">
        <div className="flex-1 max-w-xl" data-id="element-274">
          <motion.div className="bg-white p-8 rounded-xl shadow-sm border-l-4 border-[#6B46C1]" initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.3
        }} data-id="element-275">
            <p className="text-lg text-[#2D3748] leading-relaxed" data-id="element-276">
              Snakker does not need to replace Takeda’s existing agency
              partners. We work as a{' '}
              <strong className="text-[#6B46C1]" data-id="element-277">
                specialist interactive layer
              </strong>{' '}
              that helps activate approved content, capture engagement data and
              make campaign performance more measurable.
            </p>
          </motion.div>
        </div>

        <div className="flex-1 flex flex-col items-center justify-center py-8" data-id="element-278">
          {steps.map((step, index) => <Fragment key={index} data-id="element-279">
              <motion.div className={`w-full max-w-md py-4 px-6 rounded-xl text-center font-semibold shadow-sm border ${step.type === 'takeda' ? 'bg-white border-gray-200 text-[#1A202C]' : step.type === 'snakker' ? 'bg-[#6B46C1] text-white border-[#6B46C1]' : 'bg-gradient-to-r from-white to-[#6B46C1]/10 border-gray-200 text-[#1A202C]'}`} initial={{
            opacity: 0,
            y: -20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.5,
            delay: 0.4 + index * 0.15
          }} data-id="element-280">
                {step.text}
              </motion.div>

              {index < steps.length - 1 && <motion.div initial={{
            opacity: 0
          }} animate={{
            opacity: 1
          }} transition={{
            duration: 0.3,
            delay: 0.5 + index * 0.15
          }} className="py-2" data-id="element-281">
                  <ArrowDown className="w-5 h-5 text-gray-400" data-id="element-282" />
                </motion.div>}
            </Fragment>)}
        </div>
      </main>
    </div>;
}